import { Package, TrendingUp, Filter, Clock, PlaneLanding, Fingerprint, PackageSearch } from 'lucide-react';

// The reports under Analytics & Insights, each its own page at
// /commerce/insights/<v>. The sidebar lists them under the section and the
// page reads the same list, so the two can never drift.
export const INSIGHT_TABS = [
  { v: 'product', l: 'Product', Icon: Package, d: 'What each product earns, sells with, and loses at the cart' },
  { v: 'catalog', l: 'Catalog', Icon: PackageSearch, d: 'Every product in the feed: stock, price, recent sales' },
  // Retention merged into Customer Value and What's working into What We Found
  // on 24 Sep 2026; their addresses redirect (pages/commerce-insights.jsx).
  { v: 'channels', l: 'Channels', Icon: TrendingUp, d: 'Which channels open, close and assist sales' },
  { v: 'funnel', l: 'Funnel & engagement', Icon: Filter, d: 'Visit to order, by channel and new vs returning' },
  { v: 'timing', l: 'Timing', Icon: Clock, d: 'How long a sale takes, and how fast people return' },
  { v: 'arrivals', l: 'Arrivals', Icon: PlaneLanding, d: 'Where visitors land, and what each page turns into' },
  { v: 'identity', l: 'Identity', Icon: Fingerprint, d: 'How much revenue is tied to a known visitor' },
];

export const insightPath = (v) => `/commerce/insights/${v}`;
